import { CONTENT_TYPES, MESSAGE_TYPES } from '../constants';

const FIELD_LIMITS = {
  eventId: 160,
  reason: 300,
  summary: 1000,
  attempts: 800,
  nextAction: 500,
};

const hasForbiddenControl = value =>
  [...value].some(character => {
    const code = character.codePointAt(0);
    return (code < 32 && code !== 10) || code === 127;
  });

const isValidText = (value, limit) =>
  typeof value === 'string' &&
  [...value].length <= limit &&
  value.trim().length > 0 &&
  !hasForbiddenControl(value);

export const isValidCpf = cpf => {
  if (
    typeof cpf !== 'string' ||
    !/^[0-9]{11}$/.test(cpf) ||
    /^(\d)\1{10}$/.test(cpf)
  ) {
    return false;
  }
  for (let length = 9; length < 11; length += 1) {
    const sum = [...cpf.slice(0, length)].reduce(
      (total, digit, index) => total + Number(digit) * (length + 1 - index),
      0
    );
    if (Number(cpf[length]) !== ((sum * 10) % 11) % 10) return false;
  }
  return true;
};

export const isValidBiaHandoffMessage = message => {
  if (
    message?.private !== true ||
    message.messageType !== MESSAGE_TYPES.OUTGOING ||
    message.contentType !== CONTENT_TYPES.TEXT ||
    message.contentAttributes?.deleted ||
    message.attachments?.length
  ) {
    return false;
  }

  const envelope = message.contentAttributes?.biaHandoff;
  if (!envelope || Array.isArray(envelope) || typeof envelope !== 'object') {
    return false;
  }

  const expectedKeys = [
    'schemaVersion',
    'channel',
    ...Object.keys(FIELD_LIMITS),
  ];
  if (
    Object.keys(envelope).filter(key => key !== 'cpf').length !==
      expectedKeys.length ||
    !expectedKeys.every(key => Object.hasOwn(envelope, key)) ||
    Object.keys(envelope).some(
      key => key !== 'cpf' && !expectedKeys.includes(key)
    ) ||
    envelope.schemaVersion !== 1 ||
    !['web', 'whatsapp'].includes(envelope.channel)
  ) {
    return false;
  }

  return Object.entries(FIELD_LIMITS).every(([key, limit]) =>
    isValidText(envelope[key], limit)
  );
};
